import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { useLang } from '@/i18n/LangContext';

export default function Header() {
  const { lang, setLang, t, langs } = useLang();
  const [open, setOpen] = useState(false);

  const items = [
    { to: '/about', label: t.nav.about, testid: 'nav-about' },
    { to: '/services', label: t.nav.services, testid: 'nav-services' },
    { to: '/products', label: t.nav.products, testid: 'nav-products' },
    { to: '/quality', label: t.nav.quality, testid: 'nav-quality' },
    { to: '/how-we-work', label: t.nav.how, testid: 'nav-how' },
    { to: '/geography', label: t.nav.geo, testid: 'nav-geo' },
    { to: '/contacts', label: t.nav.contacts, testid: 'nav-contacts' },
  ];

  return (
    <header className="mm-header" data-testid="site-header">
      <div className="container-mm">
        <div className="row">
          <Link to="/" className="mm-logo" data-testid="logo-link" onClick={() => setOpen(false)}>
            <span className="dot" />
            МЕД<em>МИР</em>
          </Link>

          <nav className={`mm-nav ${open ? 'open' : ''}`} data-testid="main-nav">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                data-testid={it.testid}
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={() => setOpen(false)}
              >
                {it.label}
              </NavLink>
            ))}
          </nav>

          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div className="mm-lang" data-testid="lang-switcher">
              {langs.map((L) => (
                <button
                  key={L.code}
                  className={lang === L.code ? 'active' : ''}
                  onClick={() => setLang(L.code)}
                  data-testid={`lang-btn-${L.code}`}
                >
                  {L.label}
                </button>
              ))}
            </div>
            <button
              className="mm-menu-btn"
              onClick={() => setOpen((v) => !v)}
              aria-label="menu"
              data-testid="mobile-menu-toggle"
            >
              {open ? <X size={20} /> : <Menu size={20} />}
            </button>
          </div>
        </div>
      </div>
    </header>
  );
}
